import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class GetLocalStorageUseCase {
    constructor(data) {
        this.data = data;
    }
    run(key) {
        return this.data.getLocalStorage(key);
    }
}
GetLocalStorageUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GetLocalStorageUseCase_Factory() { return new GetLocalStorageUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: GetLocalStorageUseCase, providedIn: "root" });
